import React, { useState, useEffect } from 'react';
import { Form, Select, Input } from 'antd';
import { useRefCode } from 'hooks';
import type { SelectProps } from 'antd';
import { selectBoxFilterOption } from 'utils/form-utils';

interface FormItemProps {
  form: any
}

const LectureTargetFormItem = ({form}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const [codeList, setCodeList] = useState<SelectProps['options']>([]);
  const [isEtc, setIsEtc] = useState<boolean>(false);

  /* ======================================================
  * hooks
  * ====================================================== */
  const { refCodeList: lectureTargetList } = useRefCode({field:'lecture_target', status_type: 'AV'});  

  /* ======================================================
  * events
  * ====================================================== */  
  const handleChange = (value: string[]) => {
    setIsEtc(!!value.find((value) => value ==='ETC'))
  };

  /* ======================================================
  * effects
  * ====================================================== */  
  useEffect(() => {
    const options = lectureTargetList?.map((item) => {return {value: item.name, label: item.value}}) || [];
    setCodeList(options);
  }, [lectureTargetList]);

  useEffect(() => {
    if (form.getFieldValue('lecture_target'))
      setIsEtc(!!form.getFieldValue('lecture_target').find((value) => value ==='ETC'));
  }, [form.getFieldValue('lecture_target')]);

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <>
      <Form.Item name="lecture_target" style={{ width:'150px', display: 'inline-block', marginRight: '5px' }}>
        <Select 
          placeholder="교육대상 선택" 
          mode="multiple" 
          allowClear 
          optionFilterProp="label"
          filterOption={selectBoxFilterOption}
          onChange={handleChange}
          options={codeList} />                
      </Form.Item> 
      { (isEtc) && (
      <Form.Item name="target_memo" style={{ width:'calc(100% - 150px - 50px - 15px)', display: 'inline-block', marginRight: '5px' }}>
        <Input type="text" placeholder='교육대상을 입력'/>  
      </Form.Item>  
      )}
      <Form.Item name="people_count" style={{ width:'50px', display: 'inline-block', marginRight: '5px' }}>
        <Input type="number" placeholder='인원'/>  
      </Form.Item> 
   
    </>
  );
};

export default LectureTargetFormItem;
